/* Fashion ring integration only. Optical renderer and accepted engine assets are unchanged. */
(() => {
  'use strict';
  const gallery = document.getElementById('ep-gallery');
  const node = document.getElementById('diyona-fashion-3d-data');
  if (!gallery || !node || document.getElementById('caprice-spin-dialog')) return;
  const config = JSON.parse(node.textContent);
  const numericId = value => String(value || '').split('/').pop();
  const models = new Map();
  for (const entry of config.models || []) {
    for (const id of entry.variantIds || []) {
      const key = numericId(id);
      if (models.has(key)) throw Error('A fashion ring variant has more than one 3D model.');
      models.set(key, entry);
    }
  }
  if (!models.size) return;
  const finishKey = value => {
    const s = String(value || '').toLowerCase();
    return s.includes('platinum') ? 'platinum' : s.includes('rose') ? 'rose' : s.includes('white') ? 'white' : s.includes('yellow') ? 'yellow' : null;
  };
  const coarse = () => matchMedia('(pointer:coarse)').matches || matchMedia('(max-width:760px)').matches;
  const hint = () => coarse() ? 'Drag to rotate and pinch to zoom' : 'Drag to rotate and scroll to zoom';
  function chosen() {
    const id = gallery.dataset.variantId || new URLSearchParams(location.search).get('variant') || config.selectedVariant;
    const variant = config.variants.find(v => numericId(v.id) === numericId(id));
    return { variant, model: models.get(numericId(id)), finish: finishKey(variant?.metal) };
  }
  const trigger = document.createElement('button');
  trigger.type = 'button'; trigger.className = 'caprice-spin-trigger';
  trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-controls', 'caprice-spin-dialog');
  trigger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 8.5C5.8 6.8 8.7 6 12 6c5 0 9 2 9 4.5S17 15 12 15s-9-2-9-4.5"/><path d="M4 4.5v4.8h4.8M16 15l-4 4-4-4"/></svg><span>View in 3D</span>';
  const dialog = document.createElement('dialog');
  dialog.id = 'caprice-spin-dialog'; dialog.setAttribute('aria-labelledby', 'caprice-spin-title');
  dialog.innerHTML = '<button type="button" class="caprice-spin-close" aria-label="Close interactive view">×</button><div class="caprice-spin-body"><div class="caprice-spin-viewer"><div class="caprice-spin-stage"></div><footer class="caprice-spin-footer"><p id="caprice-spin-status" role="status"></p></footer></div><aside class="caprice-spin-options"><header class="caprice-spin-header"><h2 id="caprice-spin-title"></h2><p id="caprice-spin-selection"></p></header><div id="fashion-3d-selector-fields"></div><p id="caprice-spin-note"></p></aside></div>';
  document.body.appendChild(dialog);
  const stage = dialog.querySelector('.caprice-spin-stage');
  const status = dialog.querySelector('#caprice-spin-status');
  const note = dialog.querySelector('#caprice-spin-note');
  dialog.querySelector('#caprice-spin-title').textContent = config.title;
  const controls = [
    { source: 'ep-ctw-pills', key: 'ctw', label: config.secondaryLabel },
    { source: 'ep-cov-pills', key: 'ter', label: config.tertiaryLabel },
    { source: 'ep-metals', key: 'metal', label: 'Metal' },
    { source: 'ep-karats', key: 'karat', label: 'Karat' },
  ];
  const fields = dialog.querySelector('#fashion-3d-selector-fields');
  for (const control of controls) {
    const field = document.createElement('div'); field.className = 'caprice-spin-field';
    const label = document.createElement('span'); label.id = 'fashion-3d-label-' + control.key; label.textContent = control.label;
    const target = document.createElement('div'); target.className = 'fashion-3d-options';
    target.setAttribute('role', 'group'); target.setAttribute('aria-labelledby', label.id);
    control.field = field; control.target = target;
    field.append(label, target); fields.appendChild(field);
    target.addEventListener('click', event => {
      const button = event.target.closest('button'); if (!button || button.disabled) return;
      const original = [...(document.getElementById(control.source)?.querySelectorAll('button') || [])]
        .find(b => b.dataset[control.key] === button.dataset[control.key]);
      if (original && !original.disabled) original.click();
    });
  }
  let viewer, viewerPromise, selectionTicket = 0, session = 0, oldOverflow = '', lastFocus, loading;
  function syncSelectors() {
    const selected = chosen();
    dialog.querySelector('#caprice-spin-selection').textContent = selected.variant?.title || '';
    for (const control of controls) {
      const source = document.getElementById(control.source);
      const hidden = !source || getComputedStyle(source).display === 'none';
      const buttons = hidden ? [] : [...source.querySelectorAll(':scope > button')];
      control.field.hidden = hidden || !buttons.length;
      const focusedValue = control.target.contains(document.activeElement) ? document.activeElement.dataset[control.key] : null;
      const clones = buttons.map(original => {
        const button = original.cloneNode(true); button.type = 'button'; button.removeAttribute('id');
        button.querySelectorAll('[id]').forEach(child => child.removeAttribute('id'));
        button.setAttribute('aria-pressed', String(original.classList.contains('active')));
        button.setAttribute('aria-label', original.title || original.textContent || original.dataset[control.key]);
        return button;
      });
      control.target.replaceChildren(...clones);
      if (focusedValue != null) clones.find(b => b.dataset[control.key] === focusedValue)?.focus({ preventScroll: true });
    }
  }
  function attach() {
    const cells = [...gallery.querySelectorAll(':scope > .ep-img-cell')].filter(c => !c.classList.contains('ep-cell-empty'));
    const cell = cells[matchMedia('(max-width:900px)').matches ? 0 : 1] || cells[0];
    if (cell && trigger.parentElement !== cell) cell.appendChild(trigger);
    trigger.hidden = !chosen().model;
  }
  new MutationObserver(attach).observe(gallery, { childList: true });
  addEventListener('resize', attach); attach();
  function updateStatus(state) {
    if (!dialog.open || !loading) return;
    if (state.error) { loading.hidden = true; status.textContent = state.error; return; }
    loading.hidden = !state.loading;
    loading.classList.toggle('is-replacing', !!state.replacing);
    if (state.loading) loading.querySelector('span').textContent = state.message || 'Opening your ring…';
    if (state.loaded) status.textContent = hint();
  }
  async function loadSelection() {
    const ticket = ++selectionTicket, currentSession = session;
    try {
      if (!dialog.open) return;
      syncSelectors(); const selected = chosen();
      note.textContent = selected.finish === 'platinum' ? 'Platinum is shown using the white-metal preview.' : '';
      if (!selected.model || !selected.finish) {
        viewer?.dispose(); viewer = null; viewerPromise = null; ++session;
        stage.querySelector('canvas')?.remove(); loading.hidden = true;
        status.textContent = 'The interactive model is unavailable for this option.'; return;
      }
      if (!viewerPromise) {
        const canvas = document.createElement('canvas'); canvas.id = 'caprice-spin-canvas'; canvas.tabIndex = 0;
        canvas.setAttribute('aria-label', 'Interactive ring. ' + hint() + '.');
        canvas.setAttribute('aria-describedby', 'caprice-spin-status'); stage.prepend(canvas);
        globalThis.DIYONA_3D_ASSETS = config.assets;
        viewerPromise = import(config.renderer).then(module => module.createRingViewer(canvas, state => {
          if (currentSession === session) updateStatus(state);
        })).then(created => {
          if (currentSession !== session || !dialog.open) { created.dispose(); return null; }
          viewer = created; return created;
        });
      }
      const ready = await viewerPromise;
      if (!ready || ticket !== selectionTicket || !dialog.open) return;
      ready.setMetal(selected.finish);
      if (ready.entry?.id !== selected.model.id) await ready.setModel(selected.model);
      else updateStatus({ loaded: true, loading: false });
    } catch (error) {
      if (ticket !== selectionTicket) return;
      ++session; viewer?.dispose(); viewer = null; viewerPromise = null;
      stage.querySelector('canvas')?.remove(); updateStatus({ error: error.message });
    }
  }
  trigger.addEventListener('click', event => {
    event.preventDefault(); event.stopPropagation(); if (dialog.open) return;
    ++session; lastFocus = trigger; oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden'; stage.replaceChildren();
    loading = document.createElement('div'); loading.className = 'caprice-spin-loading';
    loading.innerHTML = '<span>Opening your ring…</span>'; stage.appendChild(loading);
    status.textContent = hint(); dialog.showModal(); loadSelection();
  });
  dialog.querySelector('.caprice-spin-close').addEventListener('click', () => dialog.close());
  let backdrop = false;
  dialog.addEventListener('pointerdown', event => { backdrop = event.target === dialog; });
  dialog.addEventListener('click', event => { if (backdrop && event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    ++session; ++selectionTicket; viewer?.dispose(); viewer = null; viewerPromise = null;
    stage.replaceChildren(); document.documentElement.style.overflow = oldOverflow;
    lastFocus?.focus({ preventScroll: true });
  });
  addEventListener('diyona:fashion-variant', () => { attach(); if (dialog.open) loadSelection(); });
  window.DiyonaFashionWebGL = {
    getDiagnostics: () => viewer?.diagnostics() || { loaded: false, open: dialog.open },
    getSelection: () => ({ variantId: chosen().variant?.id, modelId: chosen().model?.id, finish: chosen().finish }),
  };
})();
